/**
 * Stønad Configuration Index
 *
 * Exports all stønad type configurations.
 * Add new stønad types here as they are implemented.
 */

import hjelpestonadConfig from './hjelpestonad';

const stonadConfigs = {
  hjelpestonad: hjelpestonadConfig,
  // Future stønad types:
  // grunnstønad: grunnstønadConfig,
};

export function getStonadConfig(type) {
  const config = stonadConfigs[type];
  if (!config) {
    console.warn(`No configuration found for stønad type: ${type}`);
    return null;
  }
  return config;
}

export function getAvailableStonadTypes() {
  return Object.keys(stonadConfigs);
}

export default stonadConfigs;
